export const loginForm = [
  { name: "email", title: "E-Mail", placeholder: "E-Mail", type: "email" },
  { name: "password", title: "Password", placeholder: "Password", type: "password" },
];
